import * as React from "react"
import { Skeleton } from "@ideoz/ui"

export interface SkeletonCardProps {
  delay?: number;
  className?: string;
}

const SkeletonCard = React.forwardRef<HTMLDivElement, SkeletonCardProps>(
  ({ delay = 0, className, ...props }, ref) => {
    return (
      <div 
        ref={ref}
        className={`bg-white border border-gray-200 rounded-lg p-6 shadow-sm transition-all duration-500 ease-out ${className || ''}`}
        style={{ animationDelay: `${delay * 0.1}s` }}
        {...props}
      >
        <div className="flex items-center justify-between mb-4">
          <Skeleton className="w-8 h-8 rounded" />
          <Skeleton className="w-6 h-6 rounded" />
        </div>
        <div className="space-y-2">
          <Skeleton className="h-4 w-3/4" />
          <Skeleton className="h-4 w-1/2" />
        </div>
      </div>
    )
  }
)
SkeletonCard.displayName = "SkeletonCard"

export { SkeletonCard }
